import Vue from 'vue'
import Router from 'vue-router'

import merchhome from '@/merch/home'
import merBill from '@/merch/mer_bill'
import merchlogin from '@/merch/login'
import minfo from '@/merch/merchinfo'
import site from '@/merch/mer_site'
import setapply from '@/merch/setapply'
// import activity from '@/merch/activity'
import summary from '@/merch/daily_merch_summary'
import active from '@/merch/mer_activity_active'
import activity from '@/merch/mer_activity'
import user from '@/merch/mer_activity_user'
import activity_login from '@/merch/mer_activity_login'
import discount from '@/merch/mer_activity_discount'
import order from '@/merch/order'
import login from '@/components/login'
import phoneVerify from '@/components/phone_verify'
import preview from '@/components/preview'
import noticeView from '@/components/notice_view'
import loginNotice from '@/components/login_notice'
import privacy from '@/components/pengtai_privacy'
import client from '@/merch/client'
import transfer from '@/merch/merchTransfer'
import loginout from '@/merch/loginout_err_mer'
import empty from '@/components/empty'
import transMonitor from '@/components/trans_monitor'
import notFound from '@/components/notFound'
import catchNotFound from '@/components/catchNotFound'

Vue.use(Router)

// 判断构建类型
const IS_ADMIN_BUILD = process.env.VUE_APP_BUILD_ADMIN == "cheil-pdd1" || process.env.VUE_APP_BUILD_ADMIN == "cheil-stg"
const IS_MERCHANT_BUILD = process.env.VUE_APP_BUILD_ADMIN == "cheil-2025" || process.env.VUE_APP_BUILD_ADMIN == "cheil-stg-merchant"

export default new Router({
  mode: 'history',
  routes: [
    // 商户后台根路径直接跳转到404
    IS_MERCHANT_BUILD
      ? {
          path: '/',
          redirect: '/404'
        }
      : {
          path: '/',
          redirect: to => {
            let utype = window.sessionStorage.getItem('utype');
            let token = window.sessionStorage.getItem('token');

            // 未登录时
            if (!token || token === 'null') {
              if (IS_ADMIN_BUILD) {
                // 管理员后台跳转到登录页
                return '/login';
              } else {
                return '/';
              }
            }

            // 已登录时，根据用户类型跳转到对应首页
            if (utype === "pt") {
              // 管理员跳转到固定首页
              return '/sys_order/order';
            } else if (utype === "mer") {
              // 商户跳转到通知公告页面
              return '/mer_home/site';
            }

            return '/';
          }
        },
    {
      path: '/privacy',
      name: '',
      component: privacy
    },
    IS_ADMIN_BUILD
      ? {
          path: "/login",
          name: "系统登录",
          component: login,
        }
      : IS_MERCHANT_BUILD
      ? {
          path: "/merch/login",
          name: "商户登录",
          component: merchlogin,
        }
      : {
          path: "/",
          component: empty,
        },
    {
      path: '/phone_verify',
      name: '手机号验证',
      component: phoneVerify,
    },
    {
      path: '/preview',
      name: 'preview',
      component: preview
    },
    {
      path: '/notice_view',
      component: noticeView
    },
    {
      path: '/login_notice',
      component: loginNotice
    },
    {
      path: '/mer_home',
      name: '商户管理',
      component: merchhome,
      meta: {requireAuth: true},
      redirect:'/mer_home/minfo',
      children: [{
  			path: '/mer_home/minfo',
        name: '商户资料',
  			component: minfo,
  			meta: {requireAuth: true},
  		},{
  			path: '/mer_home/site',
        name: '通知公告',
  			component: site,
  			meta: {requireAuth: true},
  		}]
    },
    {
      path: '/mer_apply',
      name: '应用管理',
      component: merchhome,
      meta: {requireAuth: true},
      redirect:'/mer_apply/setapply',
      children: [{
  			path: '/mer_apply/setapply',
        name: '应用维护',
  			component: setapply,
  			meta: {requireAuth: true},
  		},{
  			path: '/mer_apply/client',
        name: '授权管理',
  			component: client,
  			meta: {requireAuth: true},
  		},{
  			path: '/mer_apply/transfer',
        name: '应用迁移',
  			component: transfer,
  			meta: {requireAuth: true},
  		}
      ]
    },
    {
      path: '/mer_order',
      name: '订单管理',
      component: merchhome,
      meta: {requireAuth: true},
      redirect:'/mer_order/order',
      children: [{
  			path: '/mer_order/order',
        name: '订单查看',
  			component: order,
  			meta: {requireAuth: true},
  		}
      ]
    },
    {
      path: '/mer_data',
      name: '数据分析',
      component: merchhome,
      meta: {requireAuth: true},
      redirect:'/mer_data/summary',
      children: [{
  			path: '/mer_data/summary',
        name: '每日交易额',
  			component: summary,
  			meta: {requireAuth: true},
  		},{
  			path: '/mer_data/loginout',
        name: '版署数据上报错误统计',
  			component: loginout,
  			meta: {requireAuth: true},
  		},

      ]
    },
    {
      path: '/404',
      name: '404',
      component: notFound,
      meta: {noAuth: true}
    },
    {
      path: '*',
      component: catchNotFound,
      meta: {noAuth: true}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js